import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { useSidebar } from "../context/useSidebar";
import UserDropdown from "../shared/ui/header/UserDropdown";
import LanguageSelector from "../shared/ui/header/LanguageSelector";
import NotificationsMenu from "../shared/ui/header/NotificationsMenu";
import { useBreakpoint } from "../hooks/useBreakpoint";
const AppHeader: React.FC = () => {
  const { t } = useTranslation();
  const { isMobileOpen, toggleSidebar, toggleMobileSidebar } = useSidebar();
  const { isSmallScreen } = useBreakpoint();

  const handleToggle = () => {
    if (!isSmallScreen) {
      toggleSidebar();
    } else {
      toggleMobileSidebar();
    }
  };

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault();
        inputRef.current?.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <header className="sticky top-0 z-40 w-full border-b border-border-subtle glass-effect">
      <div className="flex h-16 items-center justify-between px-4 md:px-8">
        <div className="flex items-center gap-4">
          {!isSmallScreen && (
            <button
              className="flex size-11 items-center justify-center rounded-lg text-content-secondary transition-colors duration-[--duration-fast] hover:bg-surface-sunken hover:text-content-primary"
              onClick={handleToggle}
              aria-label={t("header.toggleSidebar")}
              aria-expanded={isMobileOpen}
            >
              {isMobileOpen ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              ) : (
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="18" x2="16" y2="18" />
                </svg>
              )}
            </button>
          )}

          <Link to="/" className={`${isSmallScreen ? "flex" : "hidden"} items-center gap-3`}>
            <img src="/images/logo/icon.png" alt="Alchely" className="h-9 w-9" />
          </Link>

        </div>

        <div className="flex items-center gap-2 md:gap-4 lg:gap-6">
          <div className="flex items-center gap-3 md:gap-6">
            <LanguageSelector />
            <NotificationsMenu />
          </div>
          <div aria-hidden="true" className="h-6 w-px bg-border-subtle" />
          <UserDropdown />
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
